import React from 'react';
import { connect } from 'react-redux';

import { Field, reduxForm, formValueSelector } from 'redux-form';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import * as validator from 'helpers/Validator';
import * as format from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import { RenderError } from 'helpers/Formatter';
import renderDatePicker from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';

import { CSSTransitionGroup } from 'react-transition-group';
import { localize } from 'react-localize-redux';
import { Checkbox } from 'redux-form-material-ui';
import { getTranslatedString } from 'helpers/i18n';
import { promoPhotoAcceptedFileTypes } from 'helpers/FileHelper';

const style = {
  title_header: {
    margin: '5px -20px 10px -20px',
    backgroundColor: '#f1f1f1',
    padding: '5px 10px',
    fontSize: '14px',
    fontWeight: '800',
    color: 'rgba(78, 78, 78, 0.6)',
  },
  datePickerLabel: {
    width: '100%',
    textAlign: 'initial',
    fontSize: '11px',
    margin: '11px -10px -10px 15px',
    marginLeft: '15px',
    position: 'absolute',
    top: '-6px',
    left: '15px',
  },
};

let addPromotionForm = props => {
  const { properties, handleSubmit, is_external, translate } = props;
  return (
    <form onSubmit={handleSubmit}>
      <div className="row" style={style.title_header}>
        <div className="col-xs-12">
          <p style={{ margin: '0', textAlign: 'center' }}>
            {' '}
            {translate('landlordPortal.promotions.propertyUpcase')}{' '}
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12" style={{ margin: '10px 0' }}>
          <Field
            name="properties"
            data={properties}
            component={MultiSelectExtended}
            multiple={true}
            hintText={translate('landlordPortal.promotions.properties')}
            innerDivStyle={{
              width: '100%',
              fontSize: '15px',
              fontWeight: '100 !important',
            }}
            menuStyle={{ minWidth: '250px', fontSize: '15px' }}
            style={{ fontSize: '15px' }}
            fullWidth
            withResetSelectAllButtons
          />
          <Field name="properties" component={RenderError} />
        </div>
      </div>

      <div className="row" style={style.title_header}>
        <div className="col-xs-12">
          <p style={{ margin: '0', textAlign: 'center' }}>
            {translate('landlordPortal.promotions.promotionDetailsTitle')}
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12" style={{ margin: 'auto' }}>
          <Field
            name="name"
            component={TextField}
            label={translate('landlordPortal.promotions.promotionName')}
            validate={[validator.required]}
          />
        </div>

        <div className="col-xs-12" style={{ marginTop: '10px' }}>
          <Field
            name="description"
            component={TextField}
            label={translate('landlordPortal.promotions.description')}
            validate={[validator.required]}
            multiline
          />
        </div>

        <div className="col-xs-12" style={{ marginTop: '10px' }}>
          <Field
            name="link"
            component={TextField}
            label={translate('landlordPortal.promotions.link')}
            multiline
            validate={[validator.validURL]}
          />
        </div>

        <div className="col-xs-12" style={{ marginTop: '25px' }}>
          <label
            style={style.datePickerLabel}
            aria-label={translate('landlordPortal.promotions.expiryDate').props.children}
          >
            {translate('landlordPortal.promotions.expiryDate')}
          </label>
          <Field
            name="expiration_date"
            component={renderDatePicker}
            minDate={new Date().setDate(new Date().getDate() + 1)}
            type="date"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            validate={[validator.futureDate]}
            formatDate={format.reformatDate}
          />
        </div>

        <div className="col-xs-12" style={{ marginTop: '10px' }}>
          <div style={{ maxWidth: '259px' }}>
            <Field
              name="notify_residents"
              component={Checkbox}
              label={getTranslatedString('landlordPortal.addEventDialog.notifyResidents')}
              labelPosition="right"
              style={{ marginTop: '10px' }}
            />
          </div>
        </div>

        <div className="col-xs-12" style={{ marginTop: '10px' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '14px' }}>
              {translate('landlordPortal.promotions.isItExternal')}
            </div>
          </div>
          <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '15px' }}>
            <BooleanRadioButtons name="is_external" style={{ width: '187px', margin: 'auto' }} />
          </div>
        </div>
        <CSSTransitionGroup
          transitionName="slide_up"
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {is_external && (
            <div className="col-xs-12" style={{ margin: '10px 0' }}>
              <Field
                name="vendor"
                component={TextField}
                label={translate('landlordPortal.promotions.vendor')}
                validate={[validator.required]}
              />
            </div>
          )}
        </CSSTransitionGroup>
      </div>

      <div className="row" style={style.title_header}>
        <div className="col-xs-12">
          <p style={{ margin: '0', textAlign: 'center' }}>
            {' '}
            {translate('landlordPortal.promotions.promotionPhotoUpcase')}{' '}
          </p>
        </div>
      </div>

      <div className="row" style={{ textAlign: 'center' }}>
        <Field
          name="image"
          validate={[validator.required]}
          style={{
            border: `1px dashed ${colors.LIGHT_GRAY}`,
            width: '60%',
            margin: 'auto',
          }}
          labelText={translate('landlordPortal.promotions.addPhoto')}
          component={ReduxDropzone}
          fileValidation={promoPhotoAcceptedFileTypes}
          size={120}
          multiple={false}
        />
      </div>
      <div className="row" />
    </form>
  );
};

const selector = formValueSelector('add_promotion_form');
addPromotionForm = connect(state => ({
  is_external: selector(state, 'is_external'),
}))(addPromotionForm);

addPromotionForm = reduxForm({
  form: 'add_promotion_form',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(addPromotionForm);

export default localize()(addPromotionForm);
